export const askPinRuleType = {
    ON_ACTIVATE: 1,

    ON_MONEY: 2,

    ON_GUEST_ADD: 3,

    ON_GUEST_CHANGE: 4,
};
